import { useState } from "react";

export function useForm() {
  const [values, setValues] = useState({});

  function handleValueChange(e, props) {
    if (props) {
      setValues((values) => ({ ...values, [props.key]: props.value }));
      return;
    }
    setValues((values) => ({ ...values, [e.target.name]: e.target.value }));
  }

  return {
    values,
    setValues,
    handleValueChange,
  };
}
